var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import StackLayout from '../../layouts/stackLayout/StackLayoutComponent';
import useActiveThemeVariation from '../../../themes/hooks/UseActiveThemeVariation';
import Text from '../../core/text/TextComponent';
import Icon from '../icon/IconComponent';
var defaultSeparator = '/';
var BreadcrumbComponent = function (props) {
    var path = props.path, onPathSelected = props.onPathSelected;
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.breadcrumb; });
    var separator = useMemo(function () {
        return activeThemeVariation.customSeparator || defaultSeparator;
    }, [activeThemeVariation.customSeparator]);
    var pathParts = useMemo(function () {
        if (_.isArray(path)) {
            return path;
        }
        var cleanPath = path;
        // remove the slash at the end
        if (path.endsWith('/')) {
            cleanPath = path.slice(0, -1);
        }
        // split and remove empty items
        return cleanPath.split(separator).filter(function (x) { return x; });
    }, [path, activeThemeVariation.customSeparator]);
    var handleHomeIconPress = useCallback(function () {
        onPathSelected('', 0);
    }, []);
    return (React.createElement(StackLayout, __assign({ horizontal: true, vCenter: true }, activeThemeVariation),
        activeThemeVariation.homeIcon ? (React.createElement(React.Fragment, null,
            React.createElement(StackLayout, { onPress: pathParts.length ? handleHomeIconPress : undefined },
                React.createElement(Icon, { variationKey: activeThemeVariation.homeIconVariation, icon: activeThemeVariation.homeIcon })),
            pathParts.length ? React.createElement(Icon, { variationKey: activeThemeVariation.separatorIconVariation, icon: activeThemeVariation.separatorIcon }) : null)) : null,
        pathParts.map(function (pathPart, i) {
            var level = activeThemeVariation.homeIcon ? i + 1 : i;
            var onPressHandler = function () {
                var subPath = "" + _.take(pathParts, level).join(separator) + separator;
                onPathSelected(subPath, i);
            };
            if (pathParts.length === i + 1) {
                return (React.createElement(StackLayout, null,
                    React.createElement(Text, { variationKey: activeThemeVariation.activeTextVariation, noTranslation: true }, pathPart)));
            }
            // we don't want to render just an icon at the end
            if (!pathPart) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(StackLayout, { onPress: onPressHandler },
                    React.createElement(Text, { variationKey: activeThemeVariation.linkTextVariation, noTranslation: true }, pathPart)),
                React.createElement(Icon, { variationKey: activeThemeVariation.separatorIconVariation, icon: activeThemeVariation.separatorIcon })));
        })));
};
export default BreadcrumbComponent;
//# sourceMappingURL=BreadcrumbComponent.js.map